import React, { useContext } from 'react'
import { FormContext } from '../../views/Connectors/FormContext';

const Input = ({ key, label, placeholder, fieldValue, required, id
}) => {
    const { handleChange } = useContext(FormContext)
    return (
        <div className="mb-12 form-group" >
            <label htmlFor={label} className="form-control-label">{placeholder} {required === true ? "*" : ""}</label>
            <input type="text" className="form-control" id={label}
                placeholder={placeholder ? placeholder : ''}
                value={fieldValue ? fieldValue : ""}
                required={required}
                onChange={event => handleChange(id, event)}
            />
        </div>
    )
}

export default Input